export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Act for the Animals -- Djurens Rätt"}],"link":[{"rel":"preconnect","href":"https://res.cloudinary.com","crossorigin":""},{"rel":"dns-prefetch","href":"https://res.cloudinary.com"}],"style":[],"script":[{"id":"gtag-default-consent","data-cookieconsent":"ignore","innerHTML":"\n            window.dataLayer = window.dataLayer || [];\n            window.gtag = window.gtag || function () {\n              window.dataLayer.push(arguments);\n            };\n            if (!window.__gtagDefaultConsentInitialized) {\n              window.__gtagDefaultConsentInitialized = true;\n              window.gtag('consent', 'default', {\n                ad_storage: 'denied',\n                ad_user_data: 'denied',\n                ad_personalization: 'denied',\n                analytics_storage: 'denied',\n                functionality_storage: 'denied',\n                personalization_storage: 'denied',\n                security_storage: 'granted',\n                wait_for_update: 2000,\n              });\n              window.gtag('set', 'ads_data_redaction', true);\n              window.gtag('set', 'url_passthrough', true);\n            }\n          ","type":"text/javascript"}],"noscript":[],"charset":"utf-8","title":"Act"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const componentIslandsActive = false

export const payloadExtraction = true

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const serverPathFallback = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const stripNeverHydratedData = false

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const routeTypedFetch = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const vapor = false

export const rawVaporSlotKey = undefined

export const hasPluginDependencies = true

export const hasParallelPlugins = false

export const hasPluginHooks = false

export const hasIslandOptOutPlugins = false